export default {
  BACKGROUND_GRADIENT_ENHANCEMENT: 'background_page_gradient_enhancement',
};
